//import fsa from "fs";
import {enUSFile} from "../en-US";

export function readSupportedInstitutions() {
    let typesDict = enUSFile.interactionModel.languageModel.types;
    let inst_array = typesDict[0].values;
    let inst_names = inst_array.map(item => item.name.value);
    return inst_names;
}